<template>
  <div class=''>
    <Tnode v-if = 'list&&list.title' @select = '_select' :checkedIndex = 'checkedIndex' :dataKey = 'dataKey' :list = 'list' />
  </div>
</template>
<script>
import Tnode from './node.vue'
export default {
  data(){
    return {
      checkedIndex: '',
      checkedList: []
    }
  },
  mounted() {},
  created(){
    console.log('po',this.list)
    this._dg(this.list)
  },
  methods:{
    _getCheckedItem(){
      let checkedList = []
      let list = this.list
      this.out_dg(list,item => {
        if(item.checked){
          checkedList.push(item)
        }
      })
      return checkedList
    },
    _select(item){
      console.log(item);
      this.checkedList = this._getCheckedItem();
      this.$emit('select',this.checkedList);
    },
    _dg(item,index,parent){
      index = index || 1
      item.parent = parent || null
      item.editTitle = item.title
      item._index = index
      if(!this.expand){
        this.$set(item, 'expand', false)
        item.child = []
      }else{
        this.$set(item, 'expand', true)
        item.child = item.children
      }
      item.checked = item.checked || false
      
      if(item.checked){
        this.checkedList.push(item)
      }
      index++
      if(item.children&&item.children.length){
        for(let i in item.children){
          this._dg(item.children[i],index,item)
        }
      }
    },
    _delsuccess(item){
      console.log(this.list)
      item.checked = false
      this.$nextTick(()=>{
        this.checkedList = this._getCheckedItem()
      })
      
    },
    out_dg(item,cb){
      cb && cb(item);
      if(item.children && item.children.length){
        for(let i in item.children){
          this.out_dg(item.children[i],cb)
        }
      }
    }
  },
  props: {
    list: {},
    dataKey: 'title',
    expand: Boolean
  },
  components: {
    Tnode
  }
}
</script>
<style scoped>
</style>